const dateTimeFormats = {
  en: {
    short: {
      year: 'numeric', month: 'short', day: 'numeric', hour12: true,
    },
    long_numeric: {
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
    },
    long: {
      year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
    },
  },
  ar: {
    short: {
      year: 'numeric', month: 'long', day: 'numeric', hour12: true,
    },
    long_numeric: {
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
    },
    long: {
      year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
    },
  },
};

export default dateTimeFormats;
